const mapApiKey = "AIzaSyA-sJOz18F7QYyOTPRg1w-m-Ye_rSOCBt8";

export default mapApiKey;
